var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextbGColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62004 9.00004H9.38004L8.00004 5.32004L6.62004 9.00004ZM13.3334 1.33337H2.66671C1.93337 1.33337 1.33337 1.93337 1.33337 2.66671V13.3334C1.33337 14.0667 1.93337 14.6667 2.66671 14.6667H13.3334C14.0667 14.6667 14.6667 14.0667 14.6667 13.3334V2.66671C14.6667 1.93337 14.0667 1.33337 13.3334 1.33337ZM10.4734 11.92L9.87337 10.3334H6.11337L5.52004 11.9134C5.45904 12.0734 5.33697 12.2026 5.18069 12.2726C5.02441 12.3426 4.84672 12.3477 4.68671 12.2867C4.52669 12.2257 4.39747 12.1036 4.32745 11.9474C4.25744 11.7911 4.25237 11.6134 4.31337 11.4534L7.14671 4.24671C7.29337 3.89337 7.62671 3.66671 8.00004 3.66671C8.37337 3.66671 8.70671 3.89337 8.84671 4.24671L11.68 11.4534C11.7182 11.5511 11.7319 11.6567 11.7201 11.7609C11.7083 11.8651 11.6712 11.9649 11.6121 12.0516C11.553 12.1383 11.4736 12.2092 11.3809 12.2583C11.2882 12.3074 11.1849 12.3332 11.08 12.3334C10.8134 12.3334 10.5734 12.1667 10.4734 11.92Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbGColor);
export default __webpack_public_path__ + "static/media/textbGColor.f7fd560d45800be37322a95daacd6920.svg";
export { ForwardRef as ReactComponent };